import { useState } from 'react';
import { patchAPI } from '../../services/api.service';
import { useFetchUsers } from './useFetchUsers';

export function useSoftDeleteUser() {
  const [loading, setLoading] = useState(false);
  const { refetch } = useFetchUsers();

  const handleSoftDelete = async (userId: string) => {
    setLoading(true);
    try {
      const response = await patchAPI(`auth/users/${userId}`);
      if (response.status === 200) {
        console.log('User soft deleted successfully');
        refetch(); // Refetch the user list after deletion
      } else {
        console.error('Failed to delete user:', response.error);
      }
    } catch (err) {
      console.error('Error deleting user:', err);
    } finally {
      setLoading(false);
    }
  };

  return { handleSoftDelete, loading };
}